import Layout from '../components/layout';
import SeoContext from '../lib/seo-context';
import Link from 'next/link';
export default function FourOFour(props) {
    return (
        <SeoContext.Provider value={props.global.seo}>
            <div className="flex flex-col h-[100vh] justify-center items-center">
                <h1 className="text-default mb-20">404 - Page Not Found</h1>
                <Link href="/">
                    <a className="btn btn-md trust-border">Back to homepage</a>
                </Link>
            </div>
        </SeoContext.Provider>
    );
}
